export const CANVAS_TOGGLE_ADD_CONTEXT_EVENT = "canvas:toggle-add-context";

export type CanvasToggleAddContextDetail = {
  canvasId: string;
  anchorClientX: number;
  anchorClientY: number;
  /** Pin the popover to the header + control, not the click coordinates. */
  anchorToRailTrigger?: boolean;
};

export const CANVAS_ADD_CONTEXT_TRIGGER_SELECTOR =
  "[data-canvas-add-context-trigger]";

/** Viewport center of a rail control — used for flow placement, not popover anchor. */
export function anchorCenterFromElement(el: HTMLElement): {
  clientX: number;
  clientY: number;
} {
  const rect = el.getBoundingClientRect();
  return {
    clientX: rect.left + rect.width / 2,
    clientY: rect.top + rect.height / 2,
  };
}

export function dispatchCanvasToggleAddContext(
  canvasId: string,
  anchor: { clientX: number; clientY: number },
  options?: { anchorToRailTrigger?: boolean },
): void {
  window.dispatchEvent(
    new CustomEvent(CANVAS_TOGGLE_ADD_CONTEXT_EVENT, {
      detail: {
        canvasId,
        anchorClientX: anchor.clientX,
        anchorClientY: anchor.clientY,
        anchorToRailTrigger: options?.anchorToRailTrigger,
      } satisfies CanvasToggleAddContextDetail,
    }),
  );
}
